<template>
  <div class="ratios-pane-item" :style="{ top: `${topPx}px`, height: `${heightPx}px` }">
    <div class="core-pane">
      <RatiosPaneFillIndicator :heightPx="heightPx - 2" :fillFraction="fillFraction" />
      <RatiosPaneControls :showRemove="showRemove" @remove="emit('remove')" />
      <RatiosPaneSummary
        :usageItem="usageItem"
        :usageItems="usageItems"
        :usageIndex="usageIndex"
        :ratio="ratio"
        :quantityArea="quantityArea"
        :onCommitRatio="onCommitRatio"
        :onCommitArea="onCommitArea"
        :minRatio="minRatio"
        :minArea="minArea"
        :showAreaInput="showAreaInput"
        :titleResolver="titleResolver" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import RatiosPaneControls from '@/components/partials/inputs/RatiosPaneControls.vue'
import RatiosPaneFillIndicator from '@/components/partials/inputs/RatiosPaneFillIndicator.vue'
import RatiosPaneSummary from '@/components/partials/inputs/RatiosPaneSummary.vue'
import type { SharedUsageItem, UsageItem } from '@/schemas/general/types'

defineProps<{
  topPx: number
  heightPx: number
  fillFraction: number
  showRemove: boolean
  usageItem: UsageItem | SharedUsageItem
  usageItems: Array<UsageItem | SharedUsageItem>
  usageIndex: number
  ratio: number
  quantityArea?: number
  onCommitRatio?: (value: number) => boolean
  onCommitArea?: (value: number) => boolean
  minRatio?: number
  minArea?: number
  showAreaInput?: boolean
  titleResolver?: (usageItem: UsageItem | SharedUsageItem, usageIndex: number) => string
}>()

const emit = defineEmits<{
  remove: []
}>()
</script>

<style lang="postcss" scoped>
.ratios-pane-item {
  @apply absolute left-0 right-0;
}

.core-pane {
  @apply relative h-full w-full overflow-visible text-neutral-550;
  background-color: rgb(251 251 251 / 1);
}
</style>
